/**
 * buildCallLink — builds the full call URL with optional access code.
 *
 * Shared between copyCallLink() and openShareMenu() in GlobalCallWidget.
 */

import { Request } from "@asanrom/request-browser";
import { RoomController } from "@/control/room";
import { ApiRoom } from "@/api/api-group-room";

function buildBaseLink(roomId: string): string {
    return `${window.location.protocol}//${window.location.host}/room/${roomId}/section/call/`;
}

function appendCode(baseLink: string, code: string): string {
    const sep = baseLink.includes("?") ? "&" : "?";
    return `${baseLink}${sep}code=${encodeURIComponent(code)}`;
}

/**
 * Resolves the call link asynchronously (fetches share code if needed),
 * then invokes the callback with the final URL.
 */
export function resolveCallLink(roomId: string, callback: (url: string) => void): void {
    const baseLink = buildBaseLink(roomId);

    if (RoomController.accessCode) {
        callback(appendCode(baseLink, RoomController.accessCode));
        return;
    }

    if (!roomId) {
        callback(baseLink);
        return;
    }

    Request.Do(ApiRoom.GetRoomRoomidShare(roomId, {}))
        .onSuccess((shareInfo: any) => {
            if (shareInfo && shareInfo.share === "private-code" && shareInfo.code) {
                callback(appendCode(baseLink, shareInfo.code));
            } else {
                callback(baseLink);
            }
        })
        .onRequestError(() => {
            callback(baseLink);
        })
        .onUnexpectedError(() => {
            callback(baseLink);
        });
}
